import React from "react";
import { Typography } from "@mui/material";

import { BarcodeSticker, BarcodeDetails } from "./styles";
import { Barcode } from "../../Barcode";
import { getBarcodeSize } from "../../../constants/barcodes";

const align = ["left", "center", "right"];
const BarcodeLabel = ({ value, index }) =>
  value ? (
    <Typography variant="barcodeLabel" sx={{ textAlign: align[index] }}>
      {value}
    </Typography>
  ) : (
    <div />
  );

export const BarcodeStickers = ({
  barcode = "",
  barcodeProps = {},
  top = [],
  bottom = [],
  size = 1,
  ...rest
}) => {
  const hasTop = top?.filter(Boolean)?.length > 0;
  const hasBottom = bottom?.filter(Boolean)?.length > 0;
  const usedSpace = (hasTop ? 14 : 0) + (hasBottom ? 14 : 0) + 24;

  const dimensions = getBarcodeSize(size);
  const height =
    Number(dimensions.height.replace(/[^\d.x]/g, "")) * 96 - usedSpace;

  return (
    <BarcodeSticker className="HubBarcodeSticker-root" size={size} {...rest}>
      <BarcodeDetails>
        {top?.map((value, index) => (
          <BarcodeLabel value={value} index={index} />
        ))}
      </BarcodeDetails>
      <Barcode value={barcode} height={height} {...barcodeProps} />
      <BarcodeDetails>
        {bottom?.map((value, index) => (
          <BarcodeLabel value={value} index={index} />
        ))}
      </BarcodeDetails>
    </BarcodeSticker>
  );
};

export default BarcodeStickers;
